import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import classes from "./WordGameDetails.module.css";
import { FaArrowLeft } from "react-icons/fa6";
import { useDispatch } from 'react-redux';
import { reset } from '../components/XOGame/utils/gameFunctions';

const XOGameDetails = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [level, setLevel] = useState("1");

    return (
        <>
            <div className={classes.container}>

                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate(-1);
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                </div>


                <div className={classes.quiz_image_container}>
                        <img
                            src={"/assets/images/tic-tac-toe.png"}
                            alt={"x-o game"} className={classes.quiz_image} />
                </div>

                <p className={classes.quiz_title}>
                    X-O Game
                </p>

                <div className={classes.quiz_description_container}>
                    <p className={classes.quiz_description}>
                        Challenge your mind with this classic X-O game! Line up Xs or Os in a row — horizontally, vertically, or diagonally.
                    </p>
                </div>

                <div className={classes.quiz_description_container}>

                    <p className={classes.quiz_description_title}>
                        Choose Level
                    </p>

                    <div className={classes.levels_container}>
                        <div className={`${classes.level_container} ${level == "1" && classes.beginner_active}`}
                            onClick={() => {
                                setLevel(1)
                            }}
                        >
                            <div className={classes.level_sub_container}>
                                <div className={classes.level_info}>
                                    <img src="/assets/images/Beginner.png" alt="beginner level" className={classes.level_img} />
                                    <p className={classes.level_text}>Beginner</p>
                                </div>
                           
                            </div>
                        </div>

                        <div className={`${classes.level_container} ${level == "2" && classes.intermediate_active}`}
                            onClick={() => {
                                setLevel(2)
                            }}
                        >
                            <div className={classes.level_sub_container}>
                                <div className={classes.level_info}>
                                    <img src="/assets/images/Intermediate.png" alt="intermediate level" className={classes.level_img} />
                                    <p className={classes.level_text}>Intermediate</p>
                                </div>
                                
                            </div>
                        </div>

                        <div className={`${classes.level_container} ${level == "3" && classes.advance_active}`}
                            onClick={() => {
                                setLevel(3)
                            }}
                        >
                            <div className={classes.level_sub_container}>
                                <div className={classes.level_info}>
                                    <img src="/assets/images/Advance.png" alt="advance level" className={classes.level_img} />
                                    <p className={classes.level_text}>Advance</p>
                                </div>
                              
                            </div>
                        </div>

                    </div>

                </div>

                <button className={`${classes.play_button}`} type='button'
                    onClick={() => {
                        reset(dispatch);
                        navigate("/xo-game", {
                            state: {
                                level: level
                            }
                        })
                    }}
                >
                    Play
                </button>



            </div >

        </>
    )
}

export default XOGameDetails